import React, { useState, useEffect } from 'react';

const Testimonials: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: "Client 01",
      position: "Business Partner",
      content: "Curiye Advert transformed our brand identity completely. Their creative approach and attention to detail exceeded our expectations.",
      logo: "/images/clients/Our Clients-01.jpg",
      company: "Client 01"
    },
    {
      name: "Client 02",
      position: "Business Partner",
      content: "The social media campaign they created for us was phenomenal. Our engagement rates skyrocketed and we saw a 250% increase in online sales.",
      logo: "/images/clients/Our Clients-02.jpg",
      company: "Client 02"
    },
    {
      name: "Client 03",
      position: "Business Partner",
      content: "From logo design to complete brand strategy, Curiye Advert delivered beyond our expectations. Their event branding for our product launch was outstanding.",
      logo: "/images/clients/Our Clients-03.jpg",
      company: "Client 03"
    },
    {
      name: "Client 04",
      position: "Business Partner",
      content: "Working with Curiye Advert was a game-changer for our business. Their social media campaigns and branding helped us reach thousands of customers.",
      logo: "/images/clients/Our Clients-04.jpg",
      company: "Client 04"
    },
    {
      name: "Client 05",
      position: "Business Partner",
      content: "Their logo design and brand identity work was exceptional. They understood our vision and created a brand that truly represents our values.",
      logo: "/images/clients/Our Clients-05.jpg",
      company: "Client 05"
    },
    {
      name: "Client 06",
      position: "Business Partner",
      content: "Curiye Advert's event branding services are outstanding. They made our events memorable with their creative designs and attention to detail.",
      logo: "/images/clients/Our Clients-06.jpg",
      company: "Client 06"
    },
    {
      name: "Client 07",
      position: "Business Partner",
      content: "Professional, creative, and results-driven team. Their marketing strategies helped us achieve significant growth in our market.",
      logo: "/images/clients/Our Clients-07.jpg",
      company: "Client 07"
    }
  ];

  // Create infinite loop by duplicating testimonials
  const infiniteTestimonials = [...testimonials, ...testimonials];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="section-padding bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-brand-orange/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-brand-blue/5 rounded-full blur-3xl"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">
            Our Clients
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trusted by leading businesses across Somalia
          </p>
        </div>
        
        {/* Client Logos Grid */}
        <div className="relative max-w-6xl mx-auto">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * (100 / 5)}%)` }}
            >
              {infiniteTestimonials.map((testimonial, index) => (
                <div key={index} className="w-1/5 flex-shrink-0 px-2 sm:px-3">
                  <div className="bg-white rounded-xl p-0 text-center hover:shadow-lg transition-all duration-300 border border-gray-100">
                    <img 
                      src={testimonial.logo} 
                      alt={testimonial.company}
                      className="w-full h-32 sm:h-40 object-contain mx-auto"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={() => setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-8 sm:-translate-x-16 w-10 h-10 sm:w-12 sm:h-12 bg-white shadow-lg border border-gray-200 rounded-full flex items-center justify-center text-gray-700 hover:bg-brand-orange hover:text-white transition-all duration-300 group"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={() => setCurrentSlide((prev) => (prev + 1) % testimonials.length)}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-8 sm:translate-x-16 w-10 h-10 sm:w-12 sm:h-12 bg-white shadow-lg border border-gray-200 rounded-full flex items-center justify-center text-gray-700 hover:bg-brand-orange hover:text-white transition-all duration-300 group"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center space-x-2 mt-8">
          {Array.from({ length: Math.ceil(testimonials.length / 5) }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-brand-orange scale-125' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
